var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFuerzaOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#00b7ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-fuerza-on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_16",
    "data-name": 16
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.78,168.83a22.66,22.66,0,0,0-45.26,0c0,.38,0,.77,0,1.16a22.66,22.66,0,0,0,45.32,0C103.81,169.6,103.8,169.21,103.78,168.83ZM81.15,184.51A14.52,14.52,0,0,1,66.63,170c0-.39,0-.78.05-1.16a14.51,14.51,0,0,1,28.93,0,11.12,11.12,0,0,1,.06,1.16A14.52,14.52,0,0,1,81.15,184.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.54,158a19.7,19.7,0,0,0-34.79,0,19.44,19.44,0,0,0-2.3,8.25c0,.34,0,.68,0,1a20.37,20.37,0,0,0,.19,2.72H63.9a17.42,17.42,0,0,1-.21-2.72c0-.43,0-.89.06-1.4a17.46,17.46,0,0,1,34.8,0c0,.51.06,1,.06,1.4a17.41,17.41,0,0,1-.22,2.72h2.28a18.83,18.83,0,0,0,.2-2.72c0-.34,0-.68,0-1h0A19.44,19.44,0,0,0,98.54,158Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.57,144.58a25.64,25.64,0,0,1,13.67,21.35c0,.43,0,.87,0,1.31a24.39,24.39,0,0,1-.15,2.72h23.61l-7.82-25.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,167.24c0-.44,0-.88,0-1.31a25.23,25.23,0,0,1,3-10.74,25.69,25.69,0,0,1,10.68-10.61H16.88L27.55,170H51.17A27,27,0,0,1,51,167.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16.88 137.94 93.97 137.94 17.96 97.13 16.88 137.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.96 82.46 17.96 97.13 177.64 182.86 183.77 171.47 17.96 82.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.33 115.58 40.94 109.47 51.44 100.43 62.83 106.55 52.33 115.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.35 103.25 17.96 97.13 28.46 88.09 39.85 94.21 29.35 103.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.7 128.13 64.31 122.02 74.81 112.98 86.2 119.09 75.7 128.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.82 140.54 87.43 134.43 97.93 125.39 109.32 131.5 98.82 140.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.19 153.09 110.8 146.97 121.3 137.94 132.69 144.05 122.19 153.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.42 165.02 133.02 158.91 143.52 149.87 154.91 155.98 144.42 165.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.59 176.93 155.2 170.81 165.7 161.77 177.09 167.89 166.59 176.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.18,120.88h34.29V78.44h16.86l-10.63-11L148,48.13l-4.64-4.79-4.65,4.79L120,67.47l-10.63,11h16.86v42.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFuerzaOn);
export default __webpack_public_path__ + "static/media/ic-fuerza-on.bd304a8f3cea53a496312d1ce032e300.svg";
export { ForwardRef as ReactComponent };